export const sentryProperties = {
  ERROR_MESSAGE: {
    ERROR: 'Something went wrong!'
  }
}